import React, { FunctionComponent } from 'react';
import { WPAcfTechnologies } from 'types/acf/technologies';
import { Block, BlockContent, BlockHeader, LogosSlider } from 'components/elements';

interface OwnProps {
  whiteImages?: boolean;
  theme?: 'light' | 'grey' | 'dark' | 'green' | 'white';
  data: WPAcfTechnologies | null;
}

type TechnologiesProps = JSX.IntrinsicElements['div'] & OwnProps;

const Technologies: FunctionComponent<TechnologiesProps> = props => {
  const { data, theme = 'light', whiteImages = false } = props;

  if (!data || !data.logos) {
    return null;
  }

  const { header, logos } = data;

  return (
    <Block id="technologies" data-module="technologies" theme={theme}>
      <BlockContent>
        <BlockHeader>{header}</BlockHeader>
        <LogosSlider simple={true} logos={logos} whiteImages={whiteImages} />
      </BlockContent>
    </Block>
  );
};

export default Technologies;
